export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;

export const TIME_CONSTANTS = {
  COMMON_AD_BANNER_DELAY: 30 * SECOND,     // 30 seconds
};
